import React from 'react'
import BaseIcon from 'react-icon-base'

const GB = props => (
  <BaseIcon width="21" height="15" viewBox="0 0 21 15" {...props}>
    <title>GB</title>
    <defs>
      <rect id="path-1" x="0" y="0" width="21" height="15" rx="2" />
      <rect id="path-3" x="0.5" y="0.5" width="20" height="14" rx="1" />
    </defs>
    <g id="SMS-(In-progress)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="User-UI---Settings-with-Remider--03---768px" transform="translate(-312.000000, -829.000000)">
        <g id="Time-Preferences" transform="translate(296.000000, 376.000000)">
          <g id="Enter-phone-number:" transform="translate(0.000000, 408.000000)">
            <g id="Input" transform="translate(0.000000, 32.000000)">
              <g id="GB" transform="translate(16.000000, 13.000000)">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1" />
                </mask>
                <use id="background" fill="#22438B" xlinkHref="#path-1" />
                <polygon
                  id="band"
                  fill="#FFFFFF"
                  mask="url(#mask-2)"
                  points="2.99999997 0.999999962 0.9736328 1.02636718 1.00000002 3 17.9817609 14.0280845 20.0187781 13.9910681 19.9817619 12.0280851"
                />
                <polygon
                  id="band"
                  fill="#C7152A"
                  mask="url(#mask-2)"
                  points="2.00000002 1.00000002 0.999999967 1.99999994 18.9999994 13.9999996 20.0000006 13.0000004"
                />
                <path
                  d="M17.9999999,1.00000001 L20,0.999999992 L20.0000001,2.99999997 C20.0000001,2.99999997 8.25066254,10.3962123 3.01823819,14.028085 C2.95462366,14.0722405 1.02030163,14.0312631 1.02030163,14.0312631 L0.864800044,12.1277289 L17.9999999,1.00000001 L17.9999999,1.00000001 Z"
                  id="band"
                  fill="#FFFFFF"
                  mask="url(#mask-2)"
                />
                <polygon
                  id="band"
                  fill="#C7152A"
                  mask="url(#mask-2)"
                  points="19.0428543 0.972170082 20 1.99999999 1.9999997 14.0000002 1.00000001 13"
                />
                <polygon
                  id="cross"
                  fill="#FFFFFF"
                  mask="url(#mask-2)"
                  points="8 1 13 1 13 5 20 5 20 10 13 10 13 14 8 14 8 10 1 10 1 5 8 5"
                />
                <polygon
                  id="cross"
                  fill="#C7152A"
                  mask="url(#mask-2)"
                  points="9 1 12 1 12 6 20 6 20 9 12 9 12 14 9 14 9 9 1 9 1 6 9 6"
                />
                <mask id="mask-4" fill="white">
                  <use xlinkHref="#path-3" />
                </mask>
                <use id="overlay" strokeOpacity="0.156646286" stroke="#2F343A" xlinkHref="#path-3" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseIcon>
)

export default GB
